//components/Navbar/navbar_utils/props_utils.ts
import { NAVBAR_FILE_LIST } from "@/generated/navbarPaths";
import type { NavItemDirs } from "@interfaces";

/** Build {directory, files, subdirectories} from file paths */
export function buildNavFromPaths(paths: string[]): NavItemDirs[] {
  const anchor = "/src/pages/";
  const filtered = paths
    .map((p) => {
      const i = p.lastIndexOf(anchor);
      return i >= 0 ? p.slice(i + anchor.length) : p;
    })
    .filter((p) => p.endsWith("/variables.json"));

  const sections: Record<string, Set<string>> = {};
  for (const rel of filtered) {
    const parts = rel.split("/");
    if (parts.length < 2) continue;
    const [section, slug] = parts;
    if (!section || !slug) continue;
    const pageSlug = slug.replace(/\/?variables\.json$/, "");
    (sections[section] ??= new Set()).add(pageSlug);
  }

  return Object.keys(sections)
    .sort()
    .map((section) => ({
      directory: section,
      files: Array.from(sections[section]).sort(),
      subdirectories: [],
    }));
}

export async function fetchNavbarProps() {
  try {
    const list = Array.isArray(NAVBAR_FILE_LIST)
      ? NAVBAR_FILE_LIST
      : Array.from(NAVBAR_FILE_LIST || []);
    const data = buildNavFromPaths(list as string[]);
    console.log("✅ Navbar built:", data);
    return data;
  } catch (e) {
    console.error("fetchNavbarProps fallback error", e);
    return [];
  }
}

